import { explainer } from '../../content/explainer.js';

export function Explainer() {
  return (
    <section
      style={{
        maxWidth: '1180px',
        margin: '0 auto',
        padding: 'clamp(54px,8vw,96px) clamp(18px,5vw,64px) 0',
      }}
    >
      <div
        style={{
          borderRadius: '28px',
          padding: 'clamp(28px,4.4vw,48px)',
          background: 'var(--panel)',
          border: '1px solid var(--edge)',
          backdropFilter: 'blur(calc(var(--blur) * 1.6)) saturate(140%)',
          WebkitBackdropFilter: 'blur(calc(var(--blur) * 1.6)) saturate(140%)',
          boxShadow: 'var(--cardShadow)',
        }}
      >
        <p
          style={{
            margin: 0,
            maxWidth: '900px',
            font: "600 clamp(21px,3.1vw,35px)/1.3 'Plus Jakarta Sans',sans-serif",
            letterSpacing: '-.028em',
            color: 'var(--ink)',
            textWrap: 'pretty',
          }}
        >
          {explainer.statement}
        </p>
      </div>
    </section>
  );
}
